<div *ngIf="showToggle" class="flex gap-4 mt-4">
  <!-- Switch/Toggle -->
  <div class="relative inline-block">
    <input (change)="toggleSubscription($event)" type="checkbox" [checked]="showSubscription"
      id="hs-default-switch-with-icons"
      class="peer relative w-[3.25rem] h-7 p-px bg-gray-100 border-transparent text-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:ring-blue-600 disabled:opacity-50 disabled:pointer-events-none checked:bg-none checked:text-toggle-success checked:border-toggle-success focus:checked:border-blue-600 dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-600
      before:inline-block before:size-6 before:bg-white checked:before:bg-white before:translate-x-0 checked:before:translate-x-full before:rounded-full before:shadow before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-neutral-400 dark:checked:before:bg-blue-200">
    <label for="hs-default-switch-with-icons" class="sr-only">switch</label>
    <span
      class="peer-checked:text-white text-gray-500 size-6 absolute top-0.5 start-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200 dark:text-neutral-500">
      <svg class="flex-shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </span>
    <span
      class="peer-checked:text-success text-gray-500 size-6 absolute top-0.5 end-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200 dark:text-neutral-500">
      <svg class="flex-shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
  </div>
  <p class=" self-center  font-medium text-sm leading-none">
    {{"FORM.SUBSCRIPTION" | transloco}}
  </p>
</div>

<!-- main container for arrival / departure details-->
<div class="
 border-style
 border
 rounded-2xl p-6 bg-white flex gap-4 flex-col">

  <div class="flex gap-4">
    <div
      class="w-11 h-11 p-4 bg-blue-700 rounded-full border-8 border-sky-100 flex-col justify-center items-center gap-2.5 inline-flex">
      <div class="text-white text-base font-bold  leading-none">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2 L4 5 V6 L12 3 L20 6 V5 L12 2Z" fill="#FFFFFF" />
          <path
            d="M18.92 8.01C18.72 7.42 18.16 7 17.5 7H6.5C5.84 7 5.28 7.42 5.08 8.01L3 14V22C3 22.55 3.45 23 4 23H5C5.55 23 6 22.55 6 22V21H18V22C18 22.55 18.45 23 19 23H20C20.55 23 21 22.55 21 22V14L18.92 8.01Z"
            fill="#FFFFFF" />
          <path d="M6.5 9H17.5L19 13H5L6.5 9Z" fill="#0040DD" />
          <circle cx="7.5" cy="17.5" r="1.5" fill="#0040DD" />
          <circle cx="16.5" cy="17.5" r="1.5" fill="#0040DD" />
        </svg>
      </div>
    </div>
    <div class="
       self-center
       text-black text-xl font-bold  leading-none">
      {{"PARKIFLY.SIMPLE_SEARCH_SELECT.DEPARTURE_HEADING" | transloco}}
    </div>
  </div>

  <div class="">
    <!-- selectors container-->
    <div class="
 flex
 flex-col
 lg:flex-row
 h-auto
 lg:h-[80px]
 py-[15px]
 border
 border-style
 rounded-[5px];
 rounded-[16px]
 gap-1
 truncate">

      <div (click)="!disableStartTime && openDateDialog('departure')" [class]="
      'flex-1 truncate py-2 px-4 lg:py-0 lg:px-0 lg:pl-6 rounded-[16px] border-none lg:border-none ' +
      (disableStartTime ? 'cursor-not-allowed' : 'cursor-pointer')">
        <p class="font-bold text-primary-blue text-sm pb-2">
          {{"PARKIFLY.SIMPLE_SEARCH_SELECT.SELECT_DATETIME_DEPARTURE_LABEL" | transloco}}
        </p>
        <p class="text-sm" [ngClass]="{'text-[#717171]' : !selectedDepartureDate}">
          @if(selectedDepartureDate) {
          {{selectedDepartureDate | date : "yyyy-MM-dd HH:mm"}}
          }@else {
          {{"PARKIFLY.SIMPLE_SEARCH_SELECT.SELECT_DATETIME_DEPARTURE_PLACEHOLDER" | transloco}}
          }
        </p>
      </div>
    </div>
  </div>
</div>

<!-- arrival options-->

<!-- main container for arrival / departure details-->
<div *ngIf="!showSubscription && !isParkingPermitUser" class="
 border-style
 border
 rounded-2xl p-6 bg-white flex gap-4 flex-col">

  <div class="flex gap-4">
    <div
      class="w-11 h-11 p-4 bg-blue-700 rounded-full border-8 border-sky-100 flex-col justify-center items-center gap-2.5 inline-flex">
      <div class="text-white text-base font-bold  leading-none">
        <svg width="22" height="22" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
              d="M14.8409 8.48215H14.8241L13.4891 5.47834C13.3644 5.19825 13.1612 4.9603 12.9041 4.79326C12.647 4.62622 12.347 4.53725 12.0404 4.53711H4.95968C4.6531 4.53727 4.35313 4.62625 4.09605 4.79329C3.83897 4.96033 3.63579 5.19827 3.51108 5.47834L2.17599 8.48215H2.15911C1.87892 8.48246 1.6103 8.5939 1.41218 8.79203C1.21405 8.99015 1.10261 9.25877 1.10229 9.53896V13.2378C1.10261 13.518 1.21405 13.7866 1.41218 13.9848C1.6103 14.1829 1.87892 14.2943 2.15911 14.2946V15.6337C2.15936 15.8438 2.24294 16.0453 2.39153 16.1939C2.54013 16.3425 2.74159 16.4261 2.95173 16.4263H4.80116C5.0113 16.4261 5.21276 16.3425 5.36135 16.1939C5.50994 16.0453 5.59353 15.8438 5.59377 15.6337V14.2946H11.4063V15.6337C11.4065 15.8438 11.4901 16.0453 11.6387 16.1939C11.7873 16.3425 11.9887 16.4261 12.1989 16.4263H14.0483C14.2585 16.4261 14.4599 16.3425 14.6085 16.1939C14.7571 16.0453 14.8407 15.8438 14.8409 15.6337V14.2946C15.1211 14.2943 15.3897 14.1829 15.5879 13.9848C15.786 13.7866 15.8974 13.518 15.8977 13.2378V9.53896C15.8974 9.25877 15.786 8.99015 15.5879 8.79203C15.3897 8.5939 15.1211 8.48246 14.8409 8.48215Z"
              fill="#FFFFFF" />
            <path
              d="M4.47668 5.90767C4.51826 5.81429 4.586 5.73496 4.67172 5.67928C4.75744 5.6236 4.85746 5.59395 4.95968 5.59393H12.0404C12.1426 5.59398 12.2425 5.62364 12.3282 5.67932C12.4139 5.735 12.4817 5.81431 12.5232 5.90767L13.6674 8.48211H3.33248L4.47668 5.90767Z"
              fill="#0040DD" />
            <rect x="3.2159" y="10.8777" width="2.64204" height="1.05683" fill="#0040DD" />
            <rect x="11.142" y="10.8777" width="2.6421" height="1.05683" fill="#0040DD" />
            <path
              d="M8.49999 0.532715L0.573853 3.71516V4.85398L8.49999 1.67157L16.4261 4.85398V3.71516L8.49999 0.532715Z"
              fill="#FFFFFF" />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16.9091" height="16.9091" x="0.045" y="0.045" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div class="
       self-center
       text-black text-xl font-bold  leading-none">
      {{"PARKIFLY.SIMPLE_SEARCH_SELECT.ARRIVAL_HEADING" | transloco}}
    </div>
  </div>

  <div class="">

    <!-- selectors container-->
    <div class="
 flex
 flex-col
 lg:flex-row
 h-auto
 lg:h-[80px]
 py-[15px]
 border
 border-style
 rounded-[5px];
 rounded-[16px]
 gap-1
 truncate
 ">

      <div (click)="openDateDialog('arrival')" class="
      flex-1
      cursor-pointer
      truncate
      py-2
      px-4
      lg:py-0
      lg:px-0
      lg:pl-6
      rounded-[16px]
      border-none
      lg:border-none
      ">
        <p class="font-bold text-primary-blue text-sm pb-2">
          {{"PARKIFLY.SIMPLE_SEARCH_SELECT.SELECT_DATETIME_ARRIVAL_LABEL" | transloco}}
        </p>
        <p class="text-sm" [ngClass]="{'text-[#717171]' : !selectedArrivalDate}">
          @if(selectedArrivalDate) {
          {{selectedArrivalDate | date : "yyyy-MM-dd HH:mm"}}
          }@else {
          {{"PARKIFLY.SIMPLE_SEARCH_SELECT.SELECT_DATETIME_ARRIVAL_PLACEHOLDER" | transloco}}
          }
        </p>
      </div>
    </div>
  </div>